/**
 * WARNING: DO NOT EDIT
 * This file is auto-generated and updated by codegen
 */
import type { UpgradeManifest } from "document-model";
import { latestVersion, supportedVersions } from "./versions.js";

export const renownOidcClientUpgradeManifest: UpgradeManifest<
  typeof supportedVersions
> = {
  documentType: "renown/oidc-client",
  latestVersion,
  supportedVersions,
  upgrades: {},
};
